import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { ReactAppState } from "../utils";
import '../../../shared/i18n';
import { modalActionTypes, modalTypes, useModalOptions } from "../../hooks/useModalOptions";
import MatchModal from "../../../mls-match-list/components/MatchModal/MatchModal";
import { composeMatchStatus } from "../../../mls-match-list/utils";
import { queryStatusTypes, roleTypes } from "../../utils";
import { fetchClient } from "../../api/fetching";
import geoLocationEndpoints from "../../api/geoLocationEndpoints";

function ReactDataLayer({ forgeVariables, children, mediaQueries, queryParams, queryClient }) {
  const { t, ready } = useTranslation();

  const { period } = queryParams || {};
  const matchStatusOverride = period?.[0] ? composeMatchStatus({ period: period?.[0] }) : null;

  const { status: locationStatus, data: location } = useQuery({
    queryKey: [`geolocation`],
    queryFn: () => fetchClient({ apiURL: geoLocationEndpoints.baseUrl, endpoint: geoLocationEndpoints.geolocation }),
  });

  const { state, Component, Modal, updateModalOptions } = useModalOptions({
    initialState: {
      label: "match modal",
      component: MatchModal,
      modalType: modalTypes.animated
    }
  });

  const [isRecentGoal, setIsRecentGoal] = useState(false);
  const [roleType, setRoleType] = useState(roleTypes.clubs);

  useEffect(() => {
    if (roleType === roleTypes.clubs) {
      document.querySelectorAll("section[data-toggle=players]").forEach(item => item.style.display = "none");
      document.querySelectorAll("section[data-toggle=clubs]").forEach(item => item.style.display = "block");
    }
    else {
      document.querySelectorAll("section[data-toggle=clubs]").forEach(item => item.style.display = "none");
      document.querySelectorAll("section[data-toggle=players]").forEach(item => item.style.display = "block");
    }

    return () => {
      document.querySelectorAll("section[data-toggle=players]").forEach(item => item.style.display = "block");
      document.querySelectorAll("section[data-toggle=clubs]").forEach(item => item.style.display = "block");
    };
  }, [roleType]);

  const { show, modalData, label, modalClassName } = state || {};

  return (
    locationStatus === queryStatusTypes.loading || !ready
      ? null
      : (
        <ReactAppState.Provider
          value={{
            ...forgeVariables,
            mediaQueries,
            queryParams,
            queryClient,
            t,
            updateModalOptions,
            roles: {
              roleType,
              setRoleType
            },
            matchStatusOverride,
            recentGoal: {
              isRecentGoal,
              setIsRecentGoal
            },
            location
          }}
        >
          {
            React.Children.map(children, child => {
              return !child
                ? null
                : typeof child.type === 'string'
                  ? child
                  : React.cloneElement(child);
            })
          }
          <Modal
            className={modalClassName}
            label={t(label)}
            isOpen={show}
            onHide={() => updateModalOptions({ type: modalActionTypes.show, payload: false })}>
            <Component {...modalData} label={t(label)} closeModal={() => updateModalOptions({ type: modalActionTypes.show, payload: false })} />
          </Modal>
        </ReactAppState.Provider>
      )
  );
}

// eslint-disable-next-line no-func-assign
ReactDataLayer = React.memo(ReactDataLayer);

export default ReactDataLayer;
